import React from "react";
import { Link } from "react-router-dom";
import Header from "components/ui/Header";
import Footer from "components/Footer";
import SEO from "components/SEO";
import { developerProfiles } from "data/profilesData";

const DevelopersPage = () => {
  return (
    <div className="min-h-screen bg-[#f4faf8] overflow-x-hidden">
      <SEO
        title="AI Engineer Profiles for hiring | OctalChip"
        description="Short profiles you can share with hiring managers and technical approvers when staffing through OctalChip (dedicated, fixed scope, or flexible capacity)."
        keywords="hire AI engineers, developer profiles, staff augmentation, dedicated developers, OctalChip engineering"
        canonical="https://www.octalchip.com/developers"
      />
      <Header />
      <main className="py-10 sm:py-14">
        <div className="container mx-auto px-4 sm:px-6 md:px-8 max-w-5xl">
          <section className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 sm:p-10 mb-8">
            <p className="text-sm font-semibold tracking-wide text-[#00d690] uppercase mb-3">OctalChip</p>
            <div className="mb-4 h-0.5 w-14 rounded-full bg-[#00d690]" aria-hidden />
            <p className="text-xs font-semibold uppercase tracking-wide text-gray-400 mb-2">For client hiring review</p>
            <h1 className="text-3xl sm:text-[2.125rem] sm:leading-tight font-bold text-gray-900 mb-3">
              AI Engineer Profiles
            </h1>
            <p className="text-gray-700 text-base sm:text-lg mb-4">
              Use these pages to evaluate who you may bring on through OctalChip: role focus, strengths, and typical fit for your roadmap.
            </p>
            <p className="text-gray-500 text-sm">
              Forward a single profile to your internal approvers, or open a call to discuss availability, overlap hours, and screening steps.
            </p>
          </section>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {developerProfiles.map((developer) => (
              <article key={developer.slug} className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-1">{developer.name}</h2>
                <p className="text-[#00d690] font-medium mb-3">{developer.headline}</p>
                <p className="text-gray-600 mb-4">{developer.summary}</p>
                <ul className="space-y-1 mb-5 list-disc pl-5">
                  {developer.highlights.slice(0, 3).map((item) => (
                    <li key={item} className="text-sm text-gray-600">{item}</li>
                  ))}
                </ul>
                <Link
                  to={`/developers/${developer.slug}`}
                  className="inline-block px-4 py-2 rounded-full border border-[#00d690] text-[#00d690] hover:bg-[#00d690] hover:text-white transition-colors text-sm font-semibold"
                >
                  View profile for hiring
                </Link>
              </article>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default DevelopersPage;
